import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import SettingService from '../../services/SettingService';
import FileUploadService from '../../services/FileUploadService';
import NewsCreateRequest from './NewsCreateRequest';
import NewsDetailsResponse from './NewsDetailsResponse';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import YesNoDialog from '../../components/YesNoDialog';
import {FileUpload} from 'primereact';
import NewsService from '../../services/NewsService';
import ActionLink from '../../components/ActionLink';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import ImageUtils from '../../utils/ImageUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import ImageComponent from '../../components/inputs/ImageComponent';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import PublishToCompaniesDialog from '../../components/PublishToCompaniesDialog';
import PublishedToCompaniesList from '../../components/PublishedToCompaniesList';

class NewsContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new NewsService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: {
                translations: [],
            },
            difficultyLevels: [],
            parameters: [],
            showPublishDialog: false,
            showPublishToCompaniesDialog: false,
            showConfirmRemoveDialog: false,
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.fileUploadRefComponent = React.createRef();
        this.renderlocaleuages = this.renderlocaleuages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handlePublishToCompanies = this.handlePublishToCompanies.bind(this);
        this.publish = this.publish.bind(this);
        this.publishToCompanies = this.publishToCompanies.bind(this);
        this.viewMode = this.viewMode.bind(this);
        this.uploadPhotoHandler = this.uploadPhotoHandler.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            { 
               // iconTemporaryFileUrl: data.image,
                uploadedFile: data.image,
                element: new NewsDetailsResponse(data, this.state.supportedLocales),
            },
            () => {
                this.initAfterSetElement();
            }
        );
        if (data.status === 'ACTIVE' || data.status === 'REMOVED') {
            this.setState({
                viewMode: 'VIEW',
            });
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        console.log('---', viewMode, elementId, locale);

        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();

            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale, elementId}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new NewsCreateRequest(this.props.locale, supportedLocales)
                            : new NewsDetailsResponse(),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderlocaleuages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.props.elementId}/${locale}`;
        const detailHref = `${detailUrl}/${this.props.elementId}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && this.state.element.status === 'DRAFT',
            },
            {
                label: t('news.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: 'Publikuj do wielu',
                onClick: this.handlePublishToCompanies,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered:
                    this.state.element.status === 'DRAFT' &&
                    viewMode === 'VIEW' &&
                    this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR'),
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeNews(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('news.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('news.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        console.log('publish');
        this.setState({
            showPublishDialog: true,
        });
    }

    handlePublishToCompanies() {
        this.setState({
            showPublishToCompaniesDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('news.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    publishToCompanies(externalIds) {
        this.scrollToTop();
        this.blockUi();
        this.service
            .publishToCompanies(this.state.elementId, {externalIds})
            .then(() => {
                const {backUrl} = this.props;
                this.persistMessage('success', '', 'News zostal opublikowany do wybranych firm.');
                this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                this.setState({showPublishToCompaniesDialog: false});
                this.unblockUi();
            });
    }

    getAddSucces() {
        return t('news.createSuccess');
    }

    getUpdateSucces() {
        return t('news.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));

        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale)));

        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderlocaleuages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                colClass='col-xl-1 col-lg-2 col-md-3 col-sm-3'
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    render() {
        return (
            <div className='container-fluid news-container'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('news.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('news.publishBody')}</span>
                </YesNoDialog>
                <PublishToCompaniesDialog
                    visible={this.state.showPublishToCompaniesDialog}
                    header='Publikuj news do wielu firm'
                    body='Wybierz firmy, do ktorych chcesz opublikowac ten news.'
                    onHide={() => {
                        this.setState({showPublishToCompaniesDialog: false});
                    }}
                    onPublish={this.publishToCompanies}
                />
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('news.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('news.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'news-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('news.name'), url: '/news-list'},
            {name: t('news.details'), url: ``},
        ];
    }

    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                iconTemporaryFileUrl: uploadedFile?.uuid,
            },
        }));
    }
    }

    renderDetails() {
        const {elementId} = this.state;
        const {locale} = this.state;
        return (
           <div>
                <div className='row'>
                <PublishedToCompaniesList
                    companies={this.state.element?.publishedToCompanies}
                    rendered={this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR')}
                />
                <div className='col-md-4 col-sm-12'>
                    <InputTextComponent
                        id={`${locale}-title`}
                        name='title'
                        label={t('news.title')}
                        colClass='col-xl-12 col-lg-12 col-sm-12'
                        value={this.state.element?.translations[locale]?.title}
                        validator={this.validator}
                        validators='required|max:128'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        stateField={`element.translations[${locale}]`}
                    />
                </div>
                <div className='col-md-4 col-sm-12'>
                    <InputNumberComponent
                        id='coinsToEarn'
                        name='coinsToEarn'
                        label={t('news.coinsToEarn')}
                        colClass='col-xl-12 col-lg-12 col-sm-12'
                        min={0}
                        value={this.state.element.coinsToEarn}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                    />
                </div>
                <div className='col-md-12 col-sm-12'>
                    <InputCalendarRangeComponent
                        key={'active'}
                        idFrom={'activeFrom'}
                        idTo={'activeTo'}
                        nameTo={'activeTo'}
                        nameFrom={'activeFrom'}
                        label={t('news.activityRange')}
                        labelFrom={t('news.activityRangeFrom')}
                        labelTo={t('news.activityRangeTo')}
                        colClass='col-xl-8 col-lg-8 col-sm-12'
                        from={this.state.element.activeFrom}
                        to={this.state.element.activeTo}
                        validator={[this.validator, this.validatorDraft]}
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        showTime
                        showIcon
                        validatorsTo={`required|date|after_or_equal_datetime~${moment(
                            this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                        )
                            .format('DD-MM-YYYY HH:mm')
                            .toString()}`}
                        placeholderFrom='dd-mm-yyyy HH:mm'
                        placeholderTo='dd-mm-yyyy HH:mm'
                        validateViewMode
                        dateFormatMoment='DD-MM-YYYY HH:mm'
                        validatorsToType='after_or_equal_datetime'
                    />
                </div>
</div>
                <div className='row'>
                    <div className='form-group'>
                        <div className=' row p-label'>
                            <label>{t('news.imageLabel')}</label>
                        </div>


                        <ImageComponent
                            key='news-photo'
                            srcUrl={`${this.service.getPath()}/news-icon/${
                                this.state.element?.image?.uuid
                            }?token=${this.authService?.getToken()}`}
                            alt='News photo'
                            handleRemove={(e) => {
                                this.setState((prevState) => ({
                                    selectedFile: null,
                                    element: {
                                        ...prevState.element,
                                        image: null,
                                        removeImage: true,                                       
                                        iconTemporaryFileUrl: null
                                    },
                                }));
                            }}
                            notValidImageTypeErrorMessage={() => {
                                this.showErrorMessage(t('image.notValidImageType'));
                            }}
                            errorMessage={this.showErrorMessage}
                            imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                            fileSizeToTranslation={this.state.fileSizeToTranslation}
                            attachment={this.state.element.image}
                            setFile={this.uploadPhotoHandler}
                            t={t}
                            required={true}
                            validator={this.validator}
                            viewMode={this.viewMode()}
                            fileUploadService={this.fileUploadService}                            
                        />

                        {/* {this.state.element?.image ? (
                            <div className='col-lg-12'>
                                <img
                                    src={`${this.service.getPath()}/news-icon/${
                                        this.state.element?.image?.uuid
                                    }?token=${this.authService?.getToken()}`}
                                    alt='News icon'
                                    className='product-image'
                                    style={{height: '150px', width: 'auto'}}
                                />
                                <ActionLink
                                    className='p-link float-right'
                                    handleClick={(e) => {
                                        this.setState((prevState) => ({
                                            element: {
                                                ...prevState.element,
                                                image: null,
                                                removeImage: true,
                                            },
                                        }));
                                    }}
                                    variant='red'
                                    iconName={
                                        this.props.viewMode === 'VIEW' || this.state?.element?.status === 'ACTIVE' ? null : 'mdi-trash-can'
                                    }
                                    iconSide='left'
                                    iconSize='xs'
                                    iconColor='red'
                                />
                            </div>
                        ) : this.props.viewMode !== 'VIEW' ? (
                            <div>
                                <FileUpload
                                    ref={this.fileUploadRefComponent}
                                    uploadLabel={t('file.upload')}
                                    chooseLabel={t('file.choose')}
                                    cancelLabel={t('file.cancel')}
                                    multiple={false}
                                    customUpload
                                    className='col-lg-12'
                                    onSelect={this.onSelect}
                                    onRemove={this.onClear}
                                    onClear={this.onClear}
                                    accept='*'
                                    // validator={this.validateFileSize}
                                    maxFileSize={this.state.imgMaxSizeParameter}
                                    invalidFileSizeMessageSummary={t('global.invalidFileSizeSummary')} //{Constants.INAVALID_FILE_SIZE_MESSAGE_SUMMARY}
                                    invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + this.state.fileSizeToTranslation}
                                />{' '}
                            </div>
                        ) : null} */}
                    </div>

                    <InputTextEditorComponent
                        colClass='col-xl-12'
                        id='description'
                        name='description'
                        key={`description-${this.props.viewMode}`}
                        value={this.state.element?.translations[this.state.locale]?.description}
                        label={t('news.description')}
                        validator={this.validator}
                        validators='required'
                        rows='5'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        disabled={this.props.viewMode === 'VIEW'}
                        autoResize
                        editorRef={this.editorRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                        stateField={`element.translations[${this.state.locale}]`}
                    />
                </div>
            </div>
        );
    }
    // onSelect = (e) => {
    //     this.setState(
    //         {
    //             selectedFile: e.files[0],
    //         },
    //         () => {
    //             this.uploadHandler();
    //         }
    //     );
    // };

    // uploadHandler = async () => {
    //     const selectedFile = this.state.selectedFile;
    //     const formData = new FormData();
    //     formData.append('file', selectedFile);
    //     if (ImageUtils.notValidImageFormat(selectedFile)) {
    //         this.showErrorMessage(t('image.notValidImageType'));
    //         this.fileUploadRefComponent.current.clear();
    //         this.unblockUi();
    //         return;
    //     }
    //     this.fileUploadService
    //         .uploadAttachemnt(formData)
    //         .then((uploadedFile) => {
    //             this.setState((prevState) => ({
    //                 uploadedFile,
    //                 element: {
    //                     ...prevState.element,
    //                     iconTemporaryFileUrl: uploadedFile.uuid,
    //                 },
    //             }));
    //         })
    //         .catch((err) => {
    //             this.showErrorMessage(t('message.tooLargeFileSize'));
    //         });
    // };
    // onErrorClear = () => {
    //     this.forceUpdate();
    // };

    // onClear = () => {
    //     this.setState({
    //         selectedFile: undefined,
    //     });
    // };
}

NewsContainer.defaultProps = {
    backUrl: '/news-list',
    editUrl: '/news/edit',
    detailUrl: '/news/details',
    cancelUrl: '/news-list',
    lazy: true,
};

NewsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(NewsContainer));
